"use client";

import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import { FONT_UI } from "@/src/components/common/broadsheet/tokens";

const CategoryButton = styled(Button)(({ theme }) => ({
  fontFamily: FONT_UI,
  padding: "0.3125rem 0.6875rem",
  minWidth: 0,
  borderRadius: 0,
  textAlign: "center",
  fontWeight: 600,
  fontSize: "0.75rem",
  lineHeight: 1.4,
  whiteSpace: "nowrap",
  maxWidth: "100%",
  textTransform: "none",
  border: "1px solid",
  borderColor: theme.palette.custom?.ruleHairline,
  color: theme.palette.custom?.inkMuted,
  backgroundColor: "transparent",
  "&:hover": {
    borderColor: theme.palette.custom?.link,
    color: theme.palette.custom?.link,
    backgroundColor: theme.palette.custom?.newsprintRaised,
  },
  '&[aria-pressed="true"]': {
    backgroundColor: theme.palette.primary.main,
    borderColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
  },
  '&[aria-pressed="true"]:hover': {
    backgroundColor: theme.palette.custom?.linkHover,
    borderColor: theme.palette.custom?.linkHover,
    color: theme.palette.primary.contrastText,
  },
}));

export default CategoryButton;
